export default __webpack_public_path__ + "static/media/payonline.3b77c5f1.svg";